module.exports = __webpack_public_path__ + "img/document.a1e3effa.jpeg";